import { FormControl } from "@angular/forms";
import { Cargo } from "../interfaces/cargo";

export enum Filter {
  //Cargo
  showFilterApprovalState = 'showFilterApprovalState',
  showFilterNumberDocument = 'showFilterNumberDocument',
  showFilterContainer = 'showFilterContainer',
  showFilterDate = 'showFilterDate',
  showFilterDriver = 'showFilterDriver',
  showFilterAprovedCargo = 'showFilterAprovedCargo',
  showFilterMinistryFulfillment = 'showFilterMinistryFulfillment',
  showFilterPaymentAdvanceCargo = 'showFilterPaymentAdvanceCargo',
  showFilterPaymentExtraAdvanceCargo = 'showFilterPaymentExtraAdvanceCargo',
  showFilterPaymentAdditionalCostsCargo = 'showFilterPaymentAdditionalCostsCargo',
  showFilterPaymentBalanceCargo = 'showFilterPaymentBalanceCargo',
  showFilterPaymentState = 'showFilterPaymentState',
  showFilterMultipleCompanies = 'showFilterMultipleCompanies',
  showFilterContainerExpirationLapse = 'showFilterContainerExpirationLapse',
  showFilterCharges = 'showFilterCharges',
  showfilterlicensePlate = 'showfilterlicensePlate',
  showfilterEscortedLicensePlate = 'showfilterEscortedLicensePlate',
  showFilterImeiLock = 'showFilterImeiLock',
  showFilterLockId = 'showFilterLockId',
  showFilterTypeNameLock = 'showFilterTypeNameLock',
  showfilterManifestCargo = 'showfilterManifestCargo',
  showfilterIdCargo = 'showfilterIdCargo',
  showFilterMainConsecutive = 'showFilterMainConsecutive',
  showfilterIdBill = 'showfilterIdBill',
  showFilterTripTypeName = 'showFilterTripTypeName',
  showFilterRaiting = 'showFilterRaiting',
  showFilterTransportRequests = 'showFilterTransportRequests',
  showFilterIncident = 'showFilterIncident',
  showFilterAmount = 'showFilterAmount',
  showFilterConfirmedDriver = 'showFilterConfirmedDriver',
  showFilterFintech = 'showFilterFintech',
  showFilterOriginDestination = 'showFilterOriginDestination',
  showFilterRegimeType = 'showFilterRegimeType',
  showFilterRiskProfile = 'showFilterRiskProfile',
  showFilterCreationDateInitial = 'showFilterCreationDateInitial',
  showFilterCreationDateFinal = 'showFilterCreationDateFinal',
  showFilterWithoutPayment = 'showFilterWithoutPayment',
  showFilterLastPointExistance = 'showFilterLastPointExistance',
  showFilterLastPointLapse = 'showFilterLastPointLapse',
  showFilterErrorManifest = 'showFilterErrorManifest',
  showFilterNumberDocumentDriver = 'showFilterNumberDocumentDriver',
  showFilterOrderByTracking = 'showFilterOrderByTracking',
  showFilterByTag = 'showFilterByTag',
  showFilterCategory = 'showFilterCategory',
  showFilterPublicationZone = 'showFilterPublicationZone',
  showFilterPrevalidationValid = 'showFilterPrevalidationValid',
  showFilterRequiresPreBill = 'showFilterRequiresPreBill',
  showFilterPreBill = 'showFilterPreBill',
  showFilterAssignmentsCargo = 'showFilterAssignmentsCargo',
  showFilterTravelExpensesState = 'showFilterTravelExpensesState',
  showFilterPrevalidation = 'showFilterPrevalidation',
  showFilterUserClient = 'showFilterUserClient',
  showFilterTransportCompany = 'showFilterTransportCompany',
  // Empresa de transporte como pastilla siempre aplicada (pagos y facturación).
  showFilterTransportCompanyContext = 'showFilterTransportCompanyContext',
  //Users
  showFilterTypeUser = 'showFilterTypeUser',
  showFilterStateUser = 'showFilterStateUser',
  showFilterRole = 'showFilterRole',
  showFilterDocument = 'showFilterDocument',
  showFilterName = 'showFilterName',
  showFilterPhone = 'showFilterPhone',
  showFilterEmail = 'showFilterEmail',
  //General
  showFilterCompany = 'showFilterCompany',

  //Viáticos
  showFilterExpensesApproval = 'showFilterExpensesApproval',
  showFilterExpensesPaid = 'showFilterExpensesPaid',
  showFilterCargoConsecutive = 'showFilterCargoConsecutive',
  showFilterPaymentExpenses = 'showFilterPaymentExpenses',
  showFilterPaymentExpensesPaymentType = 'showFilterPaymentExpensesPaymentType',
  //Vehicles
  showFilterVehicleLicensePlate = 'showFilterVehicleLicensePlate',
  showFilterVehicleCompany = 'showFilterVehicleCompany',
  showFilterVehicleHolderCompany = 'showFilterVehicleHolderCompany',
  showFilterVehicleAccountState = 'showFilterVehicleAccountState',
  showFilterVehicleState = 'showFilterVehicleState',
  showFilterVehicleType = 'showFilterVehicleType',
  showFilterVehicleOwner = 'showFilterVehicleOwner',
  showFilterVehicleAdministrator = 'showFilterVehicleAdministrator',
  showFilterVehicleDriver = 'showFilterVehicleDriver',
  showFilterVehicleTrailerId = 'showFilterVehicleTrailerId',
  //Satellite Lock
  showFilterSatelliteLockId = 'showFilterSatelliteLockId',
  showFilterSatelliteLockType = 'showFilterSatelliteLockType',
  showFilterSatelliteLockStateDevice = 'showFilterSatelliteLockStateDevice',
  showFilterSatelliteLockIMEI = 'showFilterSatelliteLockIMEI',
}

export interface FilterModel {
  filterName: Filter;
  validations?: boolean;
  title?: string | string[];
  controls?: { [key: string]: FormControl | string | boolean | number | string[] };
  type?: 'input' | 'select' | 'checkbox' | 'other';
  // context: siempre aplicado pero fuera de staticFilters/"Más filtros"; lo gestiona app-transport-company-context.
  typeFilter?: 'dynamic' | 'static' | 'context';
  options?: Object;
  acceptanceFunction?: (...args: any[]) => boolean;
}
